<template>
    <v-app>
        <v-main>
            <v-row>
                <v-col>
                    <v-card>
                        <v-card-title>
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                            />
                        </v-card-title>
                        <v-data-table
                            class="elevation-1"
                            loading-text="Loading... Please wait"
                            :loading="loading"
                            :headers="headers"
                            :items="users"
                            :items-per-page="5"
                            :footer-props="{
                                showFirstLastPage: true,
                                firstIcon: 'mdi-arrow-collapse-left',
                                lastIcon: 'mdi-arrow-collapse-right',
                                prevIcon: 'mdi-minus',
                                nextIcon: 'mdi-plus'
                            }"
                            :search="search"
                        >
                            <template v-slot:item.created_at="{ item }">
                                {{ $date(item.created_at).format('DD/MM/YYYY') }}
                            </template>
                            <template v-slot:item.id="{ item }">
                                <a
                                    :href="'/developer/users/' + item.id"
                                    style="text-decoration: none; color: inherit;"
                                >
                                    <v-icon
                                        small
                                        class="mr-2"
                                    >
                                        mdi-eye
                                    </v-icon>
                                </a>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-main>
    </v-app>
</template>
<script>
export default {
    data() {
        return {
            headers: [
                {
                    text: 'Email',
                    value: 'email',
                },
                {
                    text: 'Name',
                    value: 'name',
                },
                {
                    text: 'Registered Since',
                    value: 'created_at',
                },
                {
                    text: 'Pages',
                    value: 'pagesList',
                    sortable: false,
                },
                {
                    text: 'Actions',
                    value: 'id',
                    sortable: false,
                    align: 'center',
                },
            ],
            users: [],
            loading: true,
            search: '',
        };
    },

    created() {
        this.fetchUsers();
    },

    methods: {
        fetchUsers() {
            this.loading = true;
            const self = this;
            axios
                .get("/api/developer/users")
                .then(function(response) {
                    self.loading = false;
                    self.users = response.data.map(user => ({...user, pagesList: user.pages.map(page => page.name).join(', ')}));
                });
        },
    },
};
</script>
